import { render, staticRenderFns } from "./ZadiHeader.vue?vue&type=template&id=6f7c0152&scoped=true&"
import script from "./ZadiHeader.vue?vue&type=script&lang=js&"
export * from "./ZadiHeader.vue?vue&type=script&lang=js&"
import style0 from "./ZadiHeader.vue?vue&type=style&index=0&id=6f7c0152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7c0152",
  null
  
)

export default component.exports